import { Role } from '@/core/components/auth/auth.types'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/dashboard/users/$userId/')({
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (
      auth.user?.role === Role['Front-Desk'] ||
      auth.user?.role === Role['Editor'] ||
      auth.user?.role === Role['Blogger'] ||
      auth.user?.role === Role.PropertyManager
    ) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  component: () => <div>Hello /_layout/dashboard/users/$userId/!</div>,
})
